export const getWorkoutExtraCategories = (state) => () => {
  return state.workoutExtraCategories
}

export const getWorkoutExtraSubCategories = (state) => () => {
  return state.workoutExtraSubCategories
}
